import { css } from "@emotion/core";
import { fontSizes, fonts, color } from "../../theme/Theme";

export const LoginStyles = css({
  maxWidth: "20rem",
  marginTop: "5rem",
  ".title": {
    fontSize: fontSizes.eligibilityLabel,
    fontFamily: fonts.bold
  },
  label: {
    marginBottom: "0.8rem"
  },
  ".ant-btn-link:hover, .ant-btn-link:focus": {
    color: color.darkGreen,
    backgroundColor: "transparent"
  },
  ".title-underline": {
    height: "0.25rem",
    width: "2rem",
    backgroundColor: color.primary,
    marginBottom: "1.7rem"
  }
});
